<template>
    <section class="page17">
        <div class="conteudo-reverse text-left">
            <div class="col1 text-white">
                <img
                    class="p6"
                    src="~@/assets/img/header-logo.png"
                    alt=""
                    data-aos="fade-up"
                    data-aos-delay="500"
                />
                <p
                    class="text-bold text-big p6"
                    data-aos="fade"
                    data-aos-delay="800"
                >
                    Tem interesse em saber mais sobre os produtos da LG lugar de
                    gente e a conformidade deles com a LGPD?
                </p>
                <p class="p4" data-aos="fade" data-aos-delay="1100">
                    Fale com nossos especialistas e agende uma demonstração.
                </p>
                <div
                    class="button text-bold text-center"
                    data-aos="fade-up"
                    data-aos-delay="1200"
                    
                >
                    <a href="https://www.lg.com.br/lps/agende-uma-visita/" target="_blank">Quero solicitar um contato.</a>
                </div>
            </div>
            <div class="col2">
                <img
                    class="img-shadow"
                    src="~@/assets/img/page16-img.png"
                    alt=""
                    data-aos="fade-right"
                />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page17 {
    background-image: url("~@/assets/img/page16-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 50px;
    padding-bottom: 50px;
    .conteudo-reverse {
        align-items: flex-start;
    }
    .p6 {
        padding-top: 60px;
    }
    .col1 {
        width: 556px;
    }

    .button {
        background: white;

        margin: 40px 0 0 0;
        padding: 10px 0 10px 0;
        width: 268px;
        border-radius: 50px;
        border: none;
        font-size: 1rem;
        color: $color-orange;
        cursor: pointer;
        user-select: none;

        &-area {
            text-decoration: none;
        }
    }

    .button:hover {
        background: $color-yellow;
        color: white;
        cursor: pointer;
        user-select: none;
    }

    @media (max-width: 1250px) {
        padding-left: 20px;
        padding-right: 20px;
        .conteudo-reverse {
            .col2 {
                img {
                    max-width: 100%;
                }
            }
        }
    }
    @media (max-width: 900px) {
        padding-left: 20px;
        padding-right: 20px;
        .conteudo-reverse {
            max-width: 90%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .col1 {
                width: 100%;
                padding: 0;
            }
            .col2 {
                padding-top: 30px;
            }
        }
    }
}
</style> 